__turbopack_context__.v({
  "input": "full-ssn-input-module-scss-module__AQTxIq__input",
});
